import { ActionTypes } from 'utils/constants';

const initialState = {};

export const giving = (state = initialState, action) => {
    switch(action.type) {
        case ActionTypes.FETCH_GIVING_AMOUNT + '_PENDING': {
            return {
                ...state,
                loading: true
            };
        }
        case ActionTypes.FETCH_GIVING_AMOUNT + '_FULFILLED': {
            return {
                ...state,
                loading: false,
                givingAmount: action.payload?.data?.giving_amount
            };
        }
        default: {
            return state;
        }
    }
};
